'use client';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { getWishlist } from '@/redux/thunk/wishlist-thunk';
import { fetchBrands, fetchCategories } from '@/redux/thunk/categories-thunk';
import { cn } from '@/utils/cn';
import useTranslation from '@/hooks/useTranslation';
import Popover from '@/app/components/Popover';
import AllWishlistModals from '@/app/wishlist/components/AllWishlistModals';
import { setIsOpenLoginSignup } from '@/redux/reducers/auth-reducer';
import {
  setIsOpenGlobalSearchModal,
  setSearchKey,
} from '@/redux/reducers/search-reducer';
import { setIsVisiblePromotionOffer } from '@/redux/reducers/global-settings-reducer';
import fetchGlobalSettings from '@/redux/thunk/global-setting-thunk';
import { fetchWheelData } from '@/redux/thunk/spin-the-wheel-thunk';
import MobileHeaderMenu from './MobileHeaderMenu';
import { secondaryNavItems } from './menuList';
import PromotionalTopBanner from './components/PromotionalTopBanner';
import MainNavTopRow from './components/MainNavTopRow';
import MainNavBottomRow from './components/MainNavBottomRow';
// import NoInternet from '../NoInternet';

function AppHeader({ className, isOnline = true }) {
  const dispatch = useDispatch();
  const path = usePathname();
  const t = useTranslation();

  const includedPath = path === '/' || path === '/products';

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { items: categories, brands } = useSelector(
    (state) => state.categories,
  );
  const { isInitiated } = useSelector((state) => state.wishlist);
  const { lang, homePagePromotionalText, isVisiblePromotionOffer } =
    useSelector((state) => state.globalSettings);

  const [showPopUpNavbar, setShowPopUpNavbar] = useState(false);
  const [activePrimaryNav, setActivePrimaryNav] = useState(null);
  const [isSubmenuHovered, setIsSubmenuHovered] = useState(false);

  const { isOpenGlobalSearchModal } = useSelector((state) => state.search);

  // initially call global settings
  useEffect(() => {
    dispatch(fetchGlobalSettings());
    dispatch(fetchWheelData());
  }, []);

  // initially call brands
  useEffect(() => {
    dispatch(fetchBrands());
  }, []);

  // initially call categories
  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  useEffect(() => {
    if (!isInitiated && isLoggedIn) {
      dispatch(getWishlist());
    }
  }, [isInitiated, isLoggedIn]);

  // useEffect(() => {
  //   const cleanup = initializeResizeListener();

  //   return cleanup;
  // }, [initializeResizeListener]);

  useEffect(() => {
    if (!isSubmenuHovered && !showPopUpNavbar) {
      setActivePrimaryNav(null);
    }
  }, [isSubmenuHovered, showPopUpNavbar]);

  const handleMouseEnter = (current) => {
    if (current !== 'deals') {
      setActivePrimaryNav(current);
      setShowPopUpNavbar(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isSubmenuHovered && showPopUpNavbar) {
      setShowPopUpNavbar(false);
    }
  };

  const handleMouseEnterSubmenu = () => {
    setIsSubmenuHovered(true);
    setShowPopUpNavbar(true);
  };

  const handleMouseLeaveSubmenu = () => {
    setIsSubmenuHovered(false);
    setShowPopUpNavbar(false);
    setActivePrimaryNav(null);
  };

  const handleMenuClick = () => {
    setIsSubmenuHovered(false);
    setShowPopUpNavbar(false);
    setActivePrimaryNav(null);
  };

  const handleClosePromotionOffer = () => {
    dispatch(setIsVisiblePromotionOffer(!isVisiblePromotionOffer));
  };

  const onOpenLoginSignup = (data) => {
    dispatch(setIsOpenLoginSignup(data));
  };

  useEffect(() => {
    const keys = JSON.parse(localStorage.getItem('searchKeys') || '[]');
    dispatch(setSearchKey(keys?.length > 0 ? keys : []));
  }, []);

  const handleOpenGlobalSearchModal = (state) =>
    dispatch(setIsOpenGlobalSearchModal(state));

  return (
    <>
      <header
        className={cn(
          'app-header flex flex-col transition-all duration-300 ease-in-out sticky top-0 z-[200]',
          className,
        )}
      >
        <section className={cn(`shadow-main-menu`)}>
          {/* promotion and offer SHOULD COME AND DECIDE TO SHOW FROM CMS  */}
          {!isOpenGlobalSearchModal &&
          isVisiblePromotionOffer &&
          homePagePromotionalText &&
          homePagePromotionalText[lang]?.text &&
          includedPath ? (
            <PromotionalTopBanner
              promotionalBannerText={homePagePromotionalText[lang]?.text}
              onClose={() => handleClosePromotionOffer()}
            />
          ) : null}
          <div className="h-auto lg:h-[100px] bg-riverbed flex justify-between items-center text-white">
            <section className="desktop-header-menu container mx-auto hidden lg:block pt-12 lg:h-[100px]">
              <MainNavTopRow
                onOpenLoginSignup={() => onOpenLoginSignup(true)}
                useTranslation={t}
              />

              <MainNavBottomRow
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                activePrimaryNav={activePrimaryNav}
                onSearchActive={() => handleOpenGlobalSearchModal}
                globalSearchModalActive={isOpenGlobalSearchModal}
              />
            </section>

            <MobileHeaderMenu />
          </div>
          {/* {!isOnline ? <NoInternet /> : null} */}
        </section>

        <section className="relative">
          <Popover
            showPopUpNavbar={showPopUpNavbar}
            secondaryNavItems={secondaryNavItems}
            activePrimaryNav={activePrimaryNav}
            handleMouseEnterSubmenu={handleMouseEnterSubmenu}
            handleMouseLeaveSubmenu={handleMouseLeaveSubmenu}
            onMenuClick={handleMenuClick}
            categories={categories}
            brands={brands}
          />
        </section>
      </header>

      <AllWishlistModals />
    </>
  );
}

export default AppHeader;
